/**
 * Arquivo centralizado de cores para o Header
 * Mantém consistência visual e facilita atualizações de design
 */

export const HEADER_COLORS = {
  // Cores primárias
  primary: {
    yellow: '#E6D660',      // Amarelo destaque (hover/active)
    orange: '#EF6F4F',      // Laranja do botão de busca
    teal: '#3B7B99',        // Azul Petróleo (botão Portal Kre+)
  },

  // Cores de texto
  text: {
    dark: '#45474F',        // Texto escuro (padrão em header branco)
    light: 'white',         // Texto claro (em header escuro/hero)
    muted: '#999999',       // Texto secundário/desabilitado
    heading: '#384D5C',     // Cor de títulos (menu expandido)
  },

  // Cores de fundo
  background: {
    white: 'rgba(255, 255, 255, 1)',      // Branco opaco
    transparent: 'rgba(255, 255, 255, 0)', // Transparente
    lightGray: '#F5F5F5',                  // Fundo menu expandido
    divider: '#fff',                    // Linha divisória
  },

  // Estados
  states: {
    hover: '#F7941D',       // Cor ao passar mouse
    active: '#F7941D',      // Cor ativa
    disabled: '#CCCCCC',    // Desabilitado
  },

  // Borders
  borders: {
    top: '#fff',         // Borda superior do menu expandido
    light: '#fff',       // Borda clara
  },
} as const;

// Tipos para autocomplete
export type HeaderColorsType = typeof HEADER_COLORS;